import { BloodGlucoseReading } from "../../../../model/BloodGlucoseReading";
import cn from "../../../../util/cn";
import { Cell, CellProps } from "../../Cell";
import NewDataTooltipIndicator from "../../NewDataTooltipIndicator";
import {
  backgroundColorForClassification,
  foregroundColorForClassification,
} from "../colorForClassification";

type OverviewCellProps = {
  reading?: BloodGlucoseReading;
  status: "default" | "new" | "disabled";
} & CellProps;

const OverviewCell = ({ reading, status, className, ...otherProps }: OverviewCellProps) => {
  const isNew = status === "new";
  const isDisabled = status === "disabled";

  const readingBoxColor = isDisabled
    ? "bg-slate-100"
    : !reading
      ? "bg-transparent"
      : backgroundColorForClassification(reading.classification);

  const readingTextColor = !reading
    ? "text-slate-600"
    : foregroundColorForClassification(reading.classification);

  return (
    <Cell
      className={cn(
        "relative flex items-center justify-center p-2 font-semibold",
        readingBoxColor,
        className
      )}
      outline
      {...otherProps}
    >
      {isNew && (
        <div className="absolute right-2 top-2">
          <NewDataTooltipIndicator />
        </div>
      )}
      {!isDisabled && (
        <p className={readingTextColor}>
          {reading?.bloodGlucoseInMilligramsPerDeciliter.toString() ?? "-"}
        </p>
      )}
    </Cell>
  );
};

export default OverviewCell;
